import React from "react";

import * as APIModels from "../../../../models";

export default function FeeTable(params: {
    /// The fees calculated for the case from tyler tech api
    fees: APIModels.Fee[];
}): React.ReactElement {
    return (
        <>
            <table className="table table-striped table-bordered table-hover">
                <thead>
                    <tr>
                        <th>Fee Name</th>
                        <th>Fee Amount</th>
                    </tr>
                </thead>
                <tbody>
                    {params.fees.map((fee, index) =>
                        index === params.fees.length - 1 ? (
                            <tr key={index}>
                                <td
                                    style={{
                                        fontWeight: "bold",
                                        color: "#dd4444",
                                    }}
                                >
                                    {fee.description}
                                </td>
                                <td
                                    style={{
                                        fontWeight: "bold",
                                        color: "#dd4444",
                                    }}
                                >
                                    {fee.amount}
                                </td>
                            </tr>
                        ) : (
                            <tr key={index}>
                                <td>{fee.description}</td>
                                <td>{fee.amount}</td>
                            </tr>
                        )
                    )}
                </tbody>
            </table>
        </>
    );
}
